export const getSystemWideMessages =`
    query GetSystemWideMessages {
        getSystemWideMessages {
            messages {
                id
                message
                datetimeCreated
            }
        }
    }
`;
    
export const dismissSystemWideMessages = ` 
    mutation DismissSystemWideMessages($input: DismissSystemWideMessagesInput!) {
        dismissSystemWideMessages(input: $input) {
            status
        }
    }
`;
